import { useState, useEffect } from 'react';
import { Table, DatePicker, Select, Button, Modal, Form, Input, Tag } from 'antd';
import { getData, createData, updateData, deleteData } from '../api/api';

const { RangePicker } = DatePicker;

const Partners = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
    const [filters, setFilters] = useState({});
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [form] = Form.useForm();

    const columns = [
        {
            title: '№',
            key: 'index',
            width: 60, // Aniqlik uchun kenglik
            render: (_, __, index) => index + 1 + (pagination.current - 1) * pagination.pageSize,
        },
        { title: 'Nomi', dataIndex: 'name', key: 'name', width: 150 },
        { title: 'Telefon', dataIndex: 'phone', key: 'phone', width: 150 },
        { title: 'Email', dataIndex: 'email', key: 'email', width: 200 }, // Uzunroq bo'lishi mumkin
        { title: 'INN', dataIndex: 'tin', key: 'tin', width: 120 },
        { title: 'Xizmat haqqi', dataIndex: 'serviceFee', key: 'serviceFee', width: 120 },
        { title: 'API kaliti', dataIndex: 'apiKey', key: 'apiKey', width: 200 }, // Uzunroq bo'lishi mumkin
        { title: 'Call back API', dataIndex: 'callBackApi', key: 'callBackApi', width: 200 }, // Uzunroq bo'lishi mumkin
        { title: 'Manzil', dataIndex: 'address', key: 'address', width: 250 }, // Manzil uzun bo'lishi mumkin
        {
            title: 'Holati',
            dataIndex: 'status',
            key: 'status',
            width: 100,
            render: (status) =>
                status === 0 ? (
                    <Tag color="green">Faol</Tag>
                ) : (
                    <Tag color="red">Nofaol</Tag>
                ),
        },
        // {
        //     title: 'Amallar',
        //     key: 'actions',
        //     width: 200,
        //     render: (_, record) => (
        //         <>
        //             <Button size="small" onClick={() => handleUpdate(record)}>
        //                 O'zgartirish
        //             </Button>
        //             <Button size="small" danger onClick={() => handleDelete(record.id)} style={{ marginLeft: 8 }}>
        //                 O'chirish
        //             </Button>
        //         </>
        //     ),
        // },
    ];

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await getData('/admin/partner-list-by-filter', {
                page: pagination.current - 1, // Backend uchun 0 dan boshlanadi
                size: pagination.pageSize,
                status: -1, // Default status
                ...filters,
            });
            setData(response.data?.data?.content || []);
            setPagination({
                ...pagination,
                total: response.data?.data?.totalCount,
            });
        } catch (error) {
            console.error(error);
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchData();
    }, [pagination.current, pagination.pageSize, filters]);

    const handleTableChange = (newPagination) => {
        setPagination(newPagination);
    };

    const handleFilter = (values) => {
        setFilters(values);
        setPagination({ ...pagination, current: 1 }); // Filtr o'zgarganda 1-sahifaga qaytish
    };

    const handleCreate = async (values) => {
        // await createData('/dashboard', values);
        // fetchData();
        // setIsModalVisible(false);
        // form.resetFields();
    };

    const handleUpdate = async (record) => {
        // await updateData('/dashboard', record.id, record);
        // fetchData();
    };

    const handleDelete = async (id) => {
        // await deleteData('/dashboard', id);
        // fetchData();
    };

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        form.resetFields();
    };

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                <h2 style={{ margin: 0 }}>Partnerlar</h2>
                {/*<Button type="primary" onClick={showModal}>*/}
                {/*    Partner qo'shish*/}
                {/*</Button>*/}
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 16 }}>
            </div>
            <Table
                columns={columns}
                dataSource={data}
                pagination={{
                    ...pagination,
                    showTotal: (total) => `Jami: ${total} ta`,
                }}
                loading={loading}
                onChange={handleTableChange}
                rowKey="id"
                scroll={{ x: 'max-content' }} // Gorizontal scroll uchun
            />
            <Modal
                title="Ma'lumot qo'shish"
                visible={isModalVisible}
                onCancel={handleCancel}
                footer={null}
            >
                <Form form={form} onFinish={handleCreate} layout="vertical">
                    <Form.Item
                        name="name"
                        label="Nomi"
                        rules={[{ required: true, message: "Iltimos, nomini kiriting!" }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit">
                            Qo'shish
                        </Button>
                        <Button style={{ marginLeft: 8 }} onClick={handleCancel}>
                            Bekor qilish
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default Partners;